import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet } from "../../../services/apiServices";
import { endPoints } from "../../../configs/apiUrls";
import { AreaType, FilterType } from "./slice";

interface AreaListResponse {
    filterData: FilterType;
    success: boolean;
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    data: AreaType[];
}

interface FetchAreaListParams {
    page?: number;
    limit?: number;
    state?: string;
    city?: string;
    search?: string;
    sortBy?: string | null;
    sortOrder?: "asc" | "desc" | null;
    isActive?: boolean | null;
}

// Main Thunk
export const fetchAreaList = createAsyncThunk<AreaListResponse, FetchAreaListParams>(
    "area/fetchAreaList",
    async (
        {
            page = 1,
            limit = 10,
            state = "",
            city = "",
            search = "",
            sortBy = null,
            sortOrder = null,
            isActive = null,
        },
        thunkAPI
    ) => {
        try {
            // Only include isActive if a boolean was provided, NOT null
            const params = {
                page,
                limit,
                state: state || undefined,
                city: city || undefined,
                search: search || undefined,
                sortBy: sortBy || undefined,
                sortOrder: sortOrder || undefined,
                ...(isActive !== null && isActive !== undefined ? { isActive } : {})
            };
            const response = await apiGet(endPoints.GET_AREA_LIST, params);

            return {
                data: response.data,
                filterData: {
                    isActive,
                    state,
                    city,
                    search,
                    page: response.page,
                    limit: response.limit,
                    totalCount: response.total,
                    sortBy,
                    sortOrder,
                },
                success: response.success,
                page: response.page,
                limit: response.limit,
                total: response.total,
                totalPages: response.totalPages,
            };
        } catch (error) {
            return thunkAPI.rejectWithValue("Failed to fetch area list");
        }
    }
);
